import * as React from 'react';

const chunk = (value: string, blocks: number[]) => {
    if (!blocks) {
        return value;
    }
    const chars = value.split('');
    const chunked = blocks.map((block) => {
        const part = chars.splice(0, block);
        return part.join('');
    });
    if (chars.length) {
        // handle overflowing values
        chunked.push(chars.join(''));
    }
    return chunked.filter((x) => x !== '').join(' ');
};

const formatPan = (value: string) => {
    const spaceless = value.replace(/\s/g, '');
    return chunk(spaceless, [4, 4, 4, 4]);
};

interface PanProps {
    value: string;
}

const Pan = (
    {
        value,
    }: PanProps
) => <>{formatPan(value)}</>;

export default Pan;
